import { RecordType } from 'rcx_adapter';

import { ServiceNowEntity } from '../enums/ServiceNowEntity';
export type EntityConfig = {
    urlPath: string;
    nameField: string;
    extraProps?: { [key: string]: string };
};

export const fieldMap: { [key: string]: { [key in RecordType]?: string } } = {
    phone: { [RecordType.CONSUMER]: 'business_phone', [RecordType.CASE]: 'u_phone', [RecordType.CASE_TASK]: 'u_phone' },
    email: { [RecordType.CASE]: 'u_email', [RecordType.CASE_TASK]: 'u_email' },
};

export const nameEntitiesConfigs: Partial<{ [key in RecordType]: EntityConfig }> = {
    [RecordType.ACCOUNT]: {
        urlPath: ServiceNowEntity.ACCOUNT,
        nameField: 'name',
    },
    [RecordType.CONTACT]: {
        urlPath: ServiceNowEntity.CONTACT,
        nameField: 'name',
    },
    [RecordType.CONSUMER]: {
        urlPath: ServiceNowEntity.CONSUMER,
        extraProps: { sys_class_name: 'csm_consumer' },
        nameField: 'name',
    },
};

export const nameEntitiesConfigsIncident: Partial<{ [key in RecordType]: EntityConfig }> = {
    [RecordType.USER]: {
        urlPath: ServiceNowEntity.USER,
        nameField: 'name',
    },
};

export const relatedToEntitiesConfigs: Partial<{ [key in RecordType]: EntityConfig }> = {
    [RecordType.CASE]: {
        urlPath: ServiceNowEntity.CASE,
        nameField: 'number',
    },
    [RecordType.CASE_TASK]: {
        urlPath: ServiceNowEntity.CASE_TASK,
        nameField: 'number',
    },
};

export const getEntityConfigs = (isIncident: boolean): Partial<{ [key in RecordType]: EntityConfig }> => {
    return isIncident
        ? {
              ...nameEntitiesConfigsIncident,
          }
        : {
              ...nameEntitiesConfigs,
              ...relatedToEntitiesConfigs,
          };
};

export type EntityConfigKey =
    | RecordType.ACCOUNT
    | RecordType.CONTACT
    | RecordType.CONSUMER
    | RecordType.CASE
    | RecordType.CASE_TASK
    | RecordType.USER;
